<template>
  <div class="dd-title-line">
    <!-- @todo 引入props 动态改变这个值 -->
    <span class="title-text">溯源码</span>
  </div>
</template>

<style lang="less">
.dd-title-line {
  width: 100%;
  height: 21px;
  line-height: 21px;
  text-align: center;
  .title-text {
    font-size: 15px;
    color: #333333;
  }
  &::before {
    content: "";
    position: relative;
    top: -4px;
    right: 19px;
    display: inline-block;
    width: 95px;
    height: 0px;
    border: 1px solid #eeeeee;
  }
  &::after {
    content: "";
    position: relative;
    top: -4px;
    left: 19px;
    display: inline-block;
    width: 95px;
    height: 0px;
    border: 1px solid #eeeeee;
  }
}
</style>
